import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from "../pages/HomePage";
import ProtectedRoute from "components/ProtectedRoute";

// Every page except the home page is code-split, so visitors don't download
// the admin panel or other pages' heavy illustrations up front.
const ContactUsPage = lazy(() => import("../pages/ContactUsPage"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const Career = lazy(() => import("pages/Career"));
const JobDetail = lazy(() => import("pages/JobDetail"));
const Privacy = lazy(() => import("pages/PrivacyPage"));
const WorkPage = lazy(() => import("pages/WorkPage"));
const WebApplicationsPage = lazy(() => import("pages/WebApplicationsPage"));
const BackendAPIPage = lazy(() => import("pages/BackendAPIPage"));
const MobileApplicationsPage = lazy(
  () => import("pages/MobileApplicationsPage"),
);
const MVPDevelopmentPage = lazy(() => import("pages/MVPDevelopmentPage"));
const GenerativeAIPage = lazy(() => import("pages/GenerativeAIPage"));
const AdminLogin = lazy(() => import("pages/AdminLogin"));
const AdminLayout = lazy(() => import("pages/AdminLayout"));
const AdminContacts = lazy(() => import("pages/AdminContacts"));
const AdminApplications = lazy(() => import("pages/AdminApplications"));
const AdminHiring = lazy(() => import("pages/AdminHiring"));

const PageFallback = () => (
  <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
    <span
      className="spinner-border text-primary"
      role="status"
      aria-label="Loading"
    />
  </div>
);

const CustomRoutes = () => {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route exact={true} path="/" element={<HomePage />} />
        <Route exact={true} path="/contact-us" element={<ContactUsPage />} />
        <Route exact={true} path="/about-us" element={<AboutUs />} />
        <Route exact={true} path="/join-our-team" element={<Career />} />
        <Route
          exact={true}
          path="/join-our-team/:jobId"
          element={<JobDetail />}
        />
        <Route
          path="/career"
          element={<Navigate to="/join-our-team" replace />}
        />
        <Route
          path="/career/*"
          element={<Navigate to="/join-our-team" replace />}
        />
        <Route exact={true} path="/privacy" element={<Privacy />} />
        <Route exact={true} path="/work" element={<WorkPage />} />
        <Route
          exact={true}
          path="/web-applications"
          element={<WebApplicationsPage />}
        />
        <Route
          exact={true}
          path="/backend-api-development"
          element={<BackendAPIPage />}
        />
        <Route
          exact={true}
          path="/mobile-applications"
          element={<MobileApplicationsPage />}
        />
        <Route
          exact={true}
          path="/mvp-development"
          element={<MVPDevelopmentPage />}
        />
        <Route
          exact={true}
          path="/generative-ai"
          element={<GenerativeAIPage />}
        />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/contacts" replace />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="hiring" element={<AdminHiring />} />
        </Route>
        <Route
          path="/admin/*"
          element={<Navigate to="/admin/contacts" replace />}
        />
      </Routes>
    </Suspense>
  );
};

export default CustomRoutes;
